import React, { useState, useEffect } from "react";
import AuthPageLayout from "../../../../components/AuthPageLayout";
import ButtonLoader from "../../../../../../components/ButtonLoader";
import { Link, } from "react-router-dom";
import { useAppContext } from "../../../../../../context/AppContext";
import Transition from "../../../../../../components/Transition";
import { ForgotPasswordCALL } from "../../../../network/api/ForgotPassword";
import { AnimatePresence } from "framer-motion";

export default function ForgotPassword() {
    const { appData } = useAppContext();

    const [formData, setFormData] = useState({
        email: "",
        url: `${window.location.origin}/reset-password`,
        app: appData.name,
    });

    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [errorStatus, setErrorStatus] = useState("");
    const [cooldown, setCooldown] = useState(0);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });

        if (errors[name]) {
            setErrors({ ...errors, [name]: null });
        }
    };

    const handleSubmit = async (e) => {
        setErrorMessage("");
        setErrorStatus("");
        setIsLoading(true);
        e.preventDefault();

        const newErrors = {};
        if (!formData.email.trim()) newErrors.email = "Email is required";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setIsLoading(false);
            return;
        }

        try {
            const response = await ForgotPasswordCALL(formData);

            if (response && response.status === "success") {
                setSuccess(true);
                setCooldown(60);
                setErrorMessage(response.message || "Email sent successfully.");
                setErrorStatus("success");
            } else {
                setErrorMessage(response?.message || "Something went wrong. Please try again.");
                setErrorStatus("error");
            }
        } catch (error) {
            console.error("ForgotPasswordCALL Error:", error);
            setErrorMessage("Unable to process request. Please check your connection or try again later.");
            setErrorStatus("error");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        let timer;
        if (cooldown > 0) {
            timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
        }
        return () => clearTimeout(timer);
    }, [cooldown]);

    return (
        <AuthPageLayout>
            <h4 className="text-center mb-4">Forgot {appData.name} account password ?</h4>

            {!isLoading && errorMessage ? (
                <AnimatePresence mode="wait">
                    <Transition key={"error-message"}>
                        <div className={`alert alert-${errorStatus === "error" ? "danger" : "success"} alert-dismissible alert-alt solid fade show`}>
                            <strong>{errorStatus === "error" ? "Error!" : "Success!"}</strong> {errorMessage}
                        </div>
                    </Transition>
                </AnimatePresence>
            ) : null}

            <form onSubmit={handleSubmit}>
                <div className="mb-3">

                    <input
                        type="email"
                        className={`form-control ${errors.email ? "is-invalid" : ""}`}
                        placeholder="admin@example.com"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                    />
                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                </div>


                <div className="text-center mb-3">
                    <button type="submit" className="btn btn-primary btn-block" disabled={isLoading || cooldown > 0}>

                        {
                            isLoading ? <ButtonLoader /> :
                                <>
                                    <i className="fa fa-envelope mx-2" aria-hidden="true"></i>
                                    {success ? cooldown > 0 ? `Resend in ${cooldown}s` : " Resend" : "Send"}
                                </>
                        }
                    </button>
                </div>

            </form>
            <div className="new-account mt-3">
                <p>Back to <Link className="text-primary" to="/login">Sign in</Link></p>
            </div>

        </AuthPageLayout>
    );
}